
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kompetisi/eec",
      function () {
        return require("private-next-pages/kompetisi/eec/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kompetisi/eec"])
      });
    }
  